import { Label } from "./ui/label";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectSeparator, SelectTrigger, SelectValue } from "./ui/select";
import { LIVING_SITUATION_GROUPS } from "@/lib/livingSituation";

export function LivingSituationSelect({ value, onChange, testId = "client-living-situation" }) {
  return (
    <div className="space-y-2 md:col-span-2">
      <Label htmlFor="living_situation">Living Situation</Label>
      <Select value={value || ""} onValueChange={onChange}>
        <SelectTrigger data-testid={testId}>
          <SelectValue placeholder="Select living situation" />
        </SelectTrigger>
        <SelectContent className="max-h-80">
          {LIVING_SITUATION_GROUPS.map((g, i) => (
            <SelectGroup key={g.label}>
              {i > 0 && <SelectSeparator />}
              <SelectLabel className="text-[10px] uppercase tracking-wide text-slate-400">{g.label}</SelectLabel>
              {g.options.map(([code, label]) => (
                <SelectItem key={code} value={code} data-testid={`living-situation-${code}`}>{label}</SelectItem>
              ))}
            </SelectGroup>
          ))}
        </SelectContent>
      </Select>
      <p className="text-xs text-slate-500">Used to auto-tick the Living Situation boxes on state screening tools (PCST).</p>
    </div>
  );
}
